import { useComponentSelection } from "../../Hooks/useComponentSelection";
import useObservedText from "../../Hooks/useObservedText";
import { ViewBreadcrumbModel } from "../../Models/ViewBreadcrumbModel";
import IComponentProps from "../IComponentProps";
import getComponentLayout from "../Table/getComponentLayout";
import ViewBreadcrumbs from "./ViewBreadcrumbs";

function ViewBreadcrumbsComponent({ component, context, componentPath = [] }: IComponentProps<ViewBreadcrumbModel>) {
  const resolvedLabel = useObservedText(component.Label, context, "ViewBreadcrumbsComponent");
  const componentLayoutSx = getComponentLayout(component);

  const selectionProps = useComponentSelection({
    component,
    componentPath,
    isContainer: false,
  });

  return <ViewBreadcrumbs label={resolvedLabel} sx={componentLayoutSx} {...selectionProps} />;
}

export default ViewBreadcrumbsComponent;
